/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IGetCommentThreadMessage extends IMessage {
	commentThreadId: string;
	documentId: string;
}

export default class GetCommentThreadMessage extends Message {
	public static readonly TYPE: string = '93';

	public static readonly READABLE_TYPE_NAME: string = 'getComment';

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2GetCommentThreadMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentThreadId: {
				type: 'string',
				id: 1
			},
			documentId: {
				type: 'string',
				id: 2
			}
		}
	};

	public constructor( public readonly commentThreadId: string, public readonly documentId: string ) {
		super();
	}

	public toJSON(): IGetCommentThreadMessage {
		return {
			commentThreadId: this.commentThreadId,
			documentId: this.documentId
		};
	}

	public static fromJSON( object: IGetCommentThreadMessage ): GetCommentThreadMessage {
		return new GetCommentThreadMessage( object.commentThreadId, object.documentId );
	}
}
